"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.noiseOrbitSketch = void 0;
var color_1 = require("../../lib/color");
var colorsArray = (0, color_1.createColoursArray)({ r: 255, g: 0, b: 255, a: 1 }, { r: 255, g: 0, b: 0, a: 1 }, 40);
console.log(colorsArray.map(function (d) { return d.rgba; }));
var fps = 60;
var defaultConfig = {
    width: 800,
    height: 800,
    fullscreen: true,
    fill: 'rgba(9255,255,255,.5)',
    stroke: 'rgba(255,10,100,1)',
    backgroundfill: 'rgba(0,0,0,.02)',
    strokeWeight: 1,
    xDist: 0.5,
    yDist: 0.95,
    amountToNudge: 0.15
};
var radiansPerStep = function (numSteps) { return (Math.PI * 2) / numSteps; };
var makeCircle = function (numSides, radius) {
    var points = [];
    var rads = radiansPerStep(numSides);
    for (var theta = 0; theta < Math.PI * 2; theta += rads) {
        var x = 0.5 + radius * Math.cos(theta);
        var y = 0.5 + radius * Math.sin(theta);
        points.push([x, y]);
    }
    return points;
};
var noiseOrbitSketch = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return function (s) {
        var props = __assign(__assign({}, defaultConfig), overrides);
        var width = props.width, height = props.height, fullscreen = props.fullscreen, xDist = props.xDist, yDist = props.yDist, amountToNudge = props.amountToNudge;
        var w = function (val) {
            if (val == null)
                return fullscreen ? window.innerWidth : width;
            return fullscreen ? window.innerWidth * val : width * val;
        };
        var h = function (val) {
            if (val == null)
                return fullscreen ? window.innerHeight : height;
            return fullscreen ? window.innerHeight * val : height * val;
        };
        var setSize = function (width, height, s) {
            var canvWidth = props.fullscreen ? window.innerWidth : width;
            var canvHeight = props.fullscreen ? window.innerHeight : height;
            s.resizeCanvas(canvWidth, canvHeight);
        };
        // const onMouseMove = (e: MouseEvent): void => {
        // }
        // const onMouseDown = (): void => {
        // }
        // const onMouseUp = (): void => {
        // }
        s.setup = function () {
            var canvWidth = props.fullscreen ? window.innerWidth : width;
            var canvHeight = props.fullscreen ? window.innerHeight : height;
            window.addEventListener('resize', function () {
                var canvWidth = props.fullscreen ? window.innerWidth : width;
                var canvHeight = props.fullscreen ? window.innerHeight : height;
                setSize(canvWidth, canvHeight, s);
            });
            // canv.mouseMoved(onMouseMove);
            // canv.mousePressed(onMouseDown);
            // canv.mouseReleased(onMouseUp);
            s.frameRate(fps);
            setSize(canvWidth, canvHeight, s);
        };
        s.draw = function () {
            s.background(props.backgroundfill);
            var distortPolygon = function (polygon, amountToNudge) {
                if (amountToNudge === void 0) { amountToNudge = 0.1; }
                return polygon.map(function (point) {
                    var x = point[0];
                    var y = point[1];
                    var distance = s.dist(xDist, yDist, x, y);
                    var z = s.frameCount / 200;
                    var z2 = s.frameCount / 400;
                    var noiseFn = function (x, y) {
                        var noiseX = (x + 0.31) * distance * 2 + z2;
                        var noiseY = (y - 1.73) * distance * 2 + z2;
                        return s.noise(noiseX, noiseY, z);
                    };
                    var theta = noiseFn(x, y) * Math.PI * 2;
                    //const amountToNudge = 0.1;
                    var newX = x + (amountToNudge * Math.cos(theta));
                    var newY = y + (amountToNudge * Math.sin(theta));
                    return [newX, newY];
                });
            };
            function chaikin(arr, num) {
                if (num === void 0) { num = 4; }
                if (num === 0)
                    return arr;
                var l = arr.length;
                var smooth = arr.map(function (c, i) {
                    return [[0.75 * c[0] + 0.25 * arr[(i + 1) % l][0],
                            0.75 * c[1] + 0.25 * arr[(i + 1) % l][1]],
                        [0.25 * c[0] + 0.75 * arr[(i + 1) % l][0],
                            0.25 * c[1] + 0.75 * arr[(i + 1) % l][1]]];
                }).flat();
                return num === 1 ? smooth : chaikin(smooth, num - 1);
            }
            s.noFill();
            s.stroke(props.stroke);
            var colCount = 0;
            for (var radius = 0.1; radius < 0.4; radius += 0.01) {
                colCount++;
                s.beginShape();
                var circle = makeCircle(8, radius);
                var distortedCircle = distortPolygon(circle, amountToNudge);
                var smoothCircle = chaikin(distortedCircle, 4);
                smoothCircle.forEach(function (point) {
                    s.vertex(w(point[0]), h(point[1]));
                    s.stroke(colorsArray[colCount].rgba);
                });
                s.endShape(s.CLOSE); // CLOSE because the last point is not the first point
            }
            //s.stroke(fill)
        };
    };
};
exports.noiseOrbitSketch = noiseOrbitSketch;
